import React, { useEffect, useState } from "react";
import { styled } from "@mui/system";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { Button, Grid, IconButton, Paper, Typography } from "@mui/material";
import { decodeId, getPolicyholderId, formatDate } from "../../utils/helper";
import TableN from "../../reusableComponents/components/generics/TableN";

import {
  deletePolicyHolderInsuree,
  fetchPolicyHolderByInsuree,
  fetchPolicyHolderByInsureeAutoRefresh,
  fetchVerifyByInsuree,
} from "../../action";
import VerificationDialog from "./VerificationDialog";
import { useNavigate } from "react-router";
import { STAFF_MANAGEMENT, FOSA_VERIFICATION } from "../../utils/constant";

const StyledPaper = styled(Paper)(({ theme }) => ({
  ...theme.paper.paper,
}));

const StyledPaperHeader = styled(Grid)(({ theme }) => ({
  ...theme.paper.header,
  fontSize: 600,
  padding: ".8rem",
}));
function VerificationTable() {
  const SignInSuccess = useSelector((state) => state);
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [printData, setPrintData] = useState();
  const [policyHolderData, setPolicyHolderData] = useState();
  const [insureeData, setInsureeData] = useState(null);
  const [currentUser, setCurrentUSer] = useState();
  const [showDialog, setShowDialog] = useState(false);
  const [showVerificationDialog, setShowVerificationDialog] = useState(false);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [insureeToDelete, setInsureeToDelete] = useState(null);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [pageInfo, setPageInfo] = useState();
  const [endCursors, setEndCursors] = useState();
  const [startCursors, setStartCursors] = useState();
  const [filter, setFilter] = useState(false);

  const mutation = SignInSuccess?.profileReducer?.mutations;
  const policyHolderId = "c47d8640-8b8c-4d96-a220-93928c7e543f";
  // const payload = [`policyHolder_Id: ${policyHolderId}`];

  useEffect(() => {
    dispatch(fetchVerifyByInsuree());
  }, []);

  useEffect(() => {
    if (SignInSuccess?.fosaReducer?.pickerVerificationInsurees) {
      setPolicyHolderData(
        SignInSuccess?.fosaReducer?.pickerVerificationInsurees
      );
      // setInsureeData(SignInSuccess?.profileReducer?.policyHolderByInsureeResponseData)
      setPageInfo(
        SignInSuccess?.fosaReducer?.pickerVerificationInsureesPageInfo
          ?.totalCount
      );
      setStartCursors(
        SignInSuccess?.fosaReducer?.pickerVerificationInsureesPageInfo
          ?.startCursor
      );
      setEndCursors(
        SignInSuccess?.fosaReducer?.pickerVerificationInsureesPageInfo
          ?.endCursor
      );
    }
  }, [SignInSuccess]);
  useEffect(() => {
    if (SignInSuccess?.profileReducer?.printInsuree) {
      setPrintData(SignInSuccess?.profileReducer?.printInsuree);
    }
  }, [printData, SignInSuccess]);
  useEffect(() => {
    if (printData) {
      let contentType = "pdf";
      displayPrintWindow(printData, contentType);
    }
  }, [printData]);

  const openAddInsureeDailog = () => {
    setShowDialog(!showDialog);
  };

  const displayPrintWindow = (base64Data, contentType) => {
    const printWindow = window.open(
      "",
      "Print Window",
      "width=600, height=400"
    );
    printWindow.document.open();

    if (contentType === "pdf") {
      // printWindow.print(`<embed type="application/pdf" width="100%" height="100%" src="data:application/pdf;base64,${base64Data}" />`);
      printWindow.document.write(
        `<embed type="application/pdf" width="100%" height="100%" src="data:application/pdf;base64,${base64Data}" />`
      );
    } else {
      printWindow.document.write(
        `<img src="data:image/png;base64,${base64Data}" />`
      );
    }
    printWindow.document.close();
  };
  const headers = () => {
    var h = [
      t("camuNo"),
      t("First Name"),
      t("Last Name"),
      t("Gender"),
      t("dob"),
      t("Phone No."),
      t("Email Address"),
      t("Status"),
    ];

    return h;
  };
  const itemFormatters = () => {
    var row = [
      (policyHolderInsuree) =>
        !!policyHolderInsuree ? `${policyHolderInsuree.camuNumber}` : "",
      (policyHolderInsuree) =>
        !!policyHolderInsuree ? `${policyHolderInsuree.otherNames}` : "",
      (policyHolderInsuree) =>
        !!policyHolderInsuree ? `${policyHolderInsuree.lastName}` : "",

      (policyHolderInsuree) =>
        !!policyHolderInsuree
          ? `${
              policyHolderInsuree.gender.code === "M" ? t("Male") : t("Female")
            }`
          : "",
      (policyHolderInsuree) =>
        !!policyHolderInsuree ? `${formatDate(policyHolderInsuree.dob)}` : "",
      (policyHolderInsuree) =>
        !!policyHolderInsuree ? `${policyHolderInsuree.phone}` : "",
      (policyHolderInsuree) =>
        !!policyHolderInsuree.email ? `${policyHolderInsuree.email}` : "",
      (policyHolderInsuree) =>
        !!policyHolderInsuree ? `${policyHolderInsuree.status}` : "",
    ];

    return row;
  };
  const handleRowsPerPageChange = (newPageSize) => {
    setPageSize(newPageSize);
    setPage(0); // Reset to the first page when changing page size
  };
  const handleNavigation = (direction) => {
    if (direction === "forward") {
      setEndCursors(null);
    } else if (direction === "backward") {
      setStartCursors(null);
    }
  };

  const handleRowDoubleClick = (rowData) => {
    setInsureeData(rowData);
    // setShowVerificationDialog(true);
    navigate(`${FOSA_VERIFICATION}/:id=${rowData.uuid}`, { state: rowData });
  };

  // const handleClose = () => setShowVerificationDialog(false);
  return (
    <StyledPaper>
      <StyledPaperHeader container alignItems="center" direction="row">
        <Grid item alignItems="center">
          <Typography variant="h6">
            {t("Insuree")}-{pageInfo}
          </Typography>
        </Grid>
      </StyledPaperHeader>
      <TableN
        headers={headers()}
        // headerActions={headerActions}
        itemFormatters={itemFormatters()}
        items={!!policyHolderData ? policyHolderData : []}
        // error={!!errorFullfamilyPendingApproval ? errorFullfamilyPendingApproval : null}
        withSelection={"single"}
        withPagination={true}
        rowsPerPageOptions={[10, 50, 100]}
        defaultPageSize={5}
        page={page}
        pageSize={pageSize}
        count={pageInfo}
        onChangePage={(event, newPage) => {
          setPage(newPage);
          handleNavigation(newPage > page ? "forward" : "backward");
        }}
        onChangeRowsPerPage={handleRowsPerPageChange}
        onDoubleClick={handleRowDoubleClick}
      />
    </StyledPaper>
  );
}

export default VerificationTable;
